// @ts-nocheck
import {DialogContent, HStack, Input, Stack, Text} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {DialogActionTrigger, DialogBody, DialogFooter, DialogHeader, DialogRoot, DialogTitle} from "./ui/dialog";
import {Field} from "./ui/field";
import {Button} from "./ui/button";
import {addKey} from "../api/key";

const AddKeyModel = ({isCreateModelOpened, setIsCreateModelOpened, fetchData}) => {
    const [inn, setInn] = useState("");
    const [isAddButtonDisable, setIsAddButtonDisable] = useState(true);
    const [isAddButtonLoading, setIsAddButtonLoading] = useState(false);
    const [isAddError, setIsAddError] = useState(false);

    useEffect(() => {
        setIsAddButtonDisable(!(/^(\d{10}|\d{12})$/.test(inn)));
    }, [inn])

    const addKeyHandler = async () => {
        setIsAddButtonLoading(true)
        setIsAddError(false)
        try {
            await addKey(inn)
            setIsCreateModelOpened(false)
            await fetchData()
        } catch (e) {
            // @ts-ignore
            if (e.response.data.message.includes("Organization not found")) {
                setIsAddError(true)
            }
        }

        setIsAddButtonLoading(false)
    }

    useEffect(() => {
        setIsAddButtonLoading(false)
        setIsAddButtonDisable(true)
        setIsAddError(false)
        setInn("")
    }, [isCreateModelOpened]);

    return (
        <HStack position="absolute" width="100%" style={{ marginTop: '-100px'}}>
            <DialogRoot open={isCreateModelOpened}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Добавление ключа активации</DialogTitle>
                    </DialogHeader>
                    <DialogBody>
                        <form>
                            <Stack width="full">
                                <Field label="ИНН (10  или 12 цифр)" required color="#88898A">
                                    <Input value={inn} onChange={e => setInn(e.target.value)} placeholder="ИНН"
                                           color="#2F4F4F"/>
                                </Field>
                                {isAddError &&
                                    <Text textStyle="sm" color="red">Организации с таким ИНН нет в базе</Text>}
                            </Stack>
                        </form>
                    </DialogBody>
                    <DialogFooter>
                        <DialogActionTrigger asChild>
                            <Button variant="outline" onClick={() => setIsCreateModelOpened(false)}
                                    disabled={isAddButtonLoading}>Отмена</Button>
                        </DialogActionTrigger>
                        <Button disabled={isAddButtonDisable} loading={isAddButtonLoading}
                                onClick={addKeyHandler}>Добавить</Button>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </HStack>
    )
}

export default AddKeyModel